import { Container, Flex, Text, Grid, Box } from '@radix-ui/themes';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/junk-rescue/contexts/use-tenant-context';
import { Button } from '@trashlab/sitesapp/src/organizations/junk-rescue/template/components/shared/button';
import { Card } from '@trashlab/sitesapp/src/organizations/junk-rescue/template/components/shared/card';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/junk-rescue/lib/utils/get-variant-value';
import parsePhoneNumberFromString from 'libphonenumber-js';
import {
  IconMarker,
  IconPhone,
  IconEmail,
} from '@trashlab/sitesapp/src/organizations/junk-rescue/template/components/icons/icons';

export const ContactCards = () => {
  const { website } = useTenantContext();
  const hideAddressValue = useVariantValue('HIDE_ORGANIZATION_ADDRESS', 'false');
  const hideAddress = hideAddressValue.toLowerCase() === 'true';

  const formattedPhone =
    parsePhoneNumberFromString(
      website?.organization.billingPhoneNumber ?? '',
    )?.formatNational() ?? '';

  const cards = [
    {
      number: '01',
      title: 'Phone number',
      description: formattedPhone,
      icon: <IconPhone />,
      href: `tel:${website?.organization.billingPhoneNumber ?? ''}`,
    },
    // Only show location card if address is not hidden
    ...(!hideAddress
      ? [
          {
            number: '02',
            title: 'Location',
            description: [`${website?.organization.addressString}`],
            icon: <IconMarker />,
            href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              website?.organization.addressString ?? '',
            )}`,
          },
        ]
      : []),
    {
      number: hideAddress ? '02' : '03',
      title: 'Email',
      description: [`${website?.organization.billingEmail}`],
      icon: <IconEmail />,
      href: `mailto:${website?.organization.billingEmail ?? ''}`,
    },
  ];

  return (
    <Container size="4" p="8">
      <Grid columns={{ initial: '1', sm: '3' }} gap="4">
        {cards.map((card, index) => (
          <Card
            key={index}
            direction="column"
            gap="2"
            backgroundColor="#EFF3F7"
            padding="6"
          >
            <Flex direction="row" gap="2" align="center" justify="start" className="w-full pl-1">
              <Box className="w-6 flex justify-center">
                {card.icon}
              </Box>
              <Text size="2" weight="bold">
                {card.title}
              </Text>
            </Flex>
            <Button
              variant="soft"
              size="large"
              className="w-full !justify-start text-left pl-9"
              href={card.href}
            >
              <Text size="5" className="whitespace-normal line-clamp-2 w-full text-left">
                {card.description}
              </Text>
            </Button>
          </Card>
        ))}
      </Grid>
    </Container>
  );
};

export default ContactCards;
